import { registerComponent } from '../registry';
import MobileLayoutComponent from './MobileLayout.component';
import MobileLayoutEditor from './MobileLayout.editor';
import MobileLayoutProperties from './MobileLayout.properties';

// 컴포넌트 타입 상수 - constants.js에 추가할 내용과 일치하도록 함
export const COMPONENT_TYPE = 'MOBILE_LAYOUT';

// 레지스트리에 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPE,
  component: MobileLayoutComponent,
  editorComponent: MobileLayoutEditor,
  properties: MobileLayoutProperties,
  defaultProps: {
    style: {
      position: 'relative',
      width: '100vw',
      background: '#fff',
      zIndex: 9999,
      borderBottom: '1px solid #ccc'
    },
    componentProps: {
      showArrows: true,
      backgroundColor: '#fff',
      textColor: '#000',
      activeTextColor: '#3b82f6',
      scrollAmount: 100,
      menuItems: [
        { label: '내 정보', path: '/mydata' },
        { label: '자산정보', path: '/points' },
        { label: '추천인', path: '/recommendee' },
        { label: '계보도', path: '/legs' },
        { label: '멤버십투자', path: '/getmembership' },
        { label: '수당요약', path: '/getPaybacks' }
      ]
    }
  },
  category: 'navigation',
  icon: '📱',
  name: '모바일 메뉴'
});

// 컴포넌트 및 타입 내보내기
export { default as MobileLayoutComponent } from './MobileLayout.component';
export { default as MobileLayoutEditor } from './MobileLayout.editor';
export { default as MobileLayoutProperties } from './MobileLayout.properties';
export * from './MobileLayout.types'; 